import { scrollToBookingElement } from './booking-scroll-container';
import {
  BOOKING_STICKY_HEADER_SELECTOR,
  getServiceCategoryHeaderOffset,
} from './service-category-header-offset';

function hasBox(element: HTMLElement) {
  const rect = element.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0;
}

/**
 * Viewport offset a scrolled-to booking step must clear: the app's fixed or
 * sticky header plus the booking flow's own sticky strip, which is stuck under
 * that header once the page has scrolled past it.
 */
export function getBookingHeaderOffset() {
  const headers = Array.from(
    document.querySelectorAll<HTMLElement>(
      'header, [role="banner"], .site-header',
    ),
  ).flatMap((header) => {
    const style = getComputedStyle(header);
    const rect = header.getBoundingClientRect();
    return (style.position === 'fixed' || style.position === 'sticky') &&
      style.visibility !== 'hidden' &&
      rect.height > 0 &&
      rect.bottom > 0
      ? [rect]
      : [];
  });

  const strip = document.querySelector<HTMLElement>(
    BOOKING_STICKY_HEADER_SELECTOR,
  );
  const stripHeight = strip && hasBox(strip) ? strip.offsetHeight : 0;

  return getServiceCategoryHeaderOffset(headers) + stripHeight;
}

export function scrollToVisibleBookingSection(
  sections: (HTMLElement | null)[],
  behavior?: ScrollBehavior,
) {
  const section = sections.find((element) => element && hasBox(element));
  if (!section) return;

  scrollToBookingElement(section, getBookingHeaderOffset() + 16, behavior);
}
